<template>
  <div v-if="awardsList.length > 0" class="avatarslider-component">
    <swiper
      :modules="[EffectCoverflow]"
      effect="coverflow"
      :coverflowEffect="{
        rotate: 10,
        stretch: 5,
        depth: 230,
        modifier: 3,
        slideShadows: false,
      }"
      :slides-per-view="'auto'"
      :space-between="0"
      :centeredSlides="true"
      @swiper="setControlledSwiper"
      @slideChange="onSlideChange"
      class="mySwiper"
    >
      <swiper-slide
        part="swiper-slide"
        v-for="slide in awardsList"
        :key="slide.id"
        class="swiper-slide no-background"
        :class="{ 'card-item': slide.url_image != 'blank' }"
        @click="onSlideClicked(slide)"
      >
        <div v-if="slide.url_image == 'blank'" class="slide-container"></div>
        <div v-else class="ion-text-center slide-container">
          <div class="avatar-slide-img">
            <img
              class="avatar-slide-img-user"
              v-if="showUserProfile"
              :src="userData.avatar_url"
              alt=""
            />
            <img
              class="avatar-slide-img-slide"
              v-if="slide.url_image"
              :src="slide.url_image"
            />
            <img
              class="avatar-slide-img-slide"
              v-else
              src="https://placehold.co/25x25?text=Martech\nRevolution"
            />
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {
  IonButton,
  IonModal,
  IonContent,
  IonRow,
  IonCol,
  IonicSwiper,
} from "@ionic/vue";
import "swiper/swiper-bundle.min.css";
import "swiper/components/pagination/pagination.scss";
import "@ionic/vue/css/ionic-swiper.css";
import SwiperCore, { EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";

import { translate } from "../common/helper.auth";

SwiperCore.use([IonicSwiper, EffectCoverflow]);
export default {
  name: "AwardsSlider",
  props: {
    awardsList: Array,
    showUserProfile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IonButton,
    IonModal,
    IonContent,
    IonRow,
    IonCol,
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      EffectCoverflow,
      swiper: null,
    };
  },
  computed: {
    userData() {
      return this.$store.getters["user/getUserData"];
    },
  },
  methods: {
    setControlledSwiper(swiper) {
      this.swiper = swiper;
    },
    onSlideChange() {
      this.$emit("changeCurrentSlide", this.swiper.realIndex);
    },
    onSlideClicked(e) {
      this.$emit("clickedCurrentSlide", e);
    },
  },
};
</script>

<style scoped lang="scss">
.avatar-slide-img {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar-slide-img-user {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  z-index: 1;
}

.avatar-slide-img-slide {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 150px;
  height: 150px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  z-index: 2;
}
</style>
